import { useTheme } from '../../context/ThemeContext'; // Importar o hook do tema
import { FiCheck } from 'react-icons/fi';

const NotificationsPanel = ({ openOneSignal }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="space-y-6">
      {/* Botão do OneSignal */}
      <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} p-6 rounded-none shadow-sm border`}>
        <div className="text-center py-8">
          <div className={`mx-auto h-20 w-20 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-full flex items-center justify-center mb-4`}>
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-10 w-10 ${isDarkMode ? 'text-white' : 'text-gray-900'}`} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
            </svg>
          </div>
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'} mb-2`}>Gerenciar Notificações Push</h3>
          <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mb-6`}>Configure e gerencie suas notificações push através do OneSignal</p>

          <button
            onClick={openOneSignal}
            className="px-6 py-3 bg-black hover:bg-gray-900 dark:bg-white dark:hover:bg-gray-100 dark:text-black text-white rounded-none font-medium transition-colors flex items-center justify-center mx-auto border border-transparent dark:border-gray-800 shadow-sm"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
            </svg>
            Abrir OneSignal
          </button>

          <div className={`mt-8 p-4 ${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'} rounded-none text-left`}>
            <h4 className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'} mb-2`}>O que você pode fazer no OneSignal:</h4>
            <ul className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} space-y-1`}>
              <li className="flex items-start">
                <FiCheck className="text-green-500 mr-2" />
                <span>Enviar notificações para seus usuários</span>
              </li>
              <li className="flex items-start">
                <FiCheck className="text-green-500 mr-2" />
                <span>Segmentar audiências específicas</span>
              </li>
              <li className="flex items-start">
                <FiCheck className="text-green-500 mr-2" />
                <span>Analisar o desempenho das notificações</span>
              </li>
              <li className="flex items-start">
                <FiCheck className="text-green-500 mr-2" />
                <span>Agendar notificações futuras</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Seção de histórico de notificações (opcional) */}
      {/*  <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} p-6 rounded-none shadow-sm border`}>
        <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'} mb-4`}>Histórico de Notificações</h3>
        <div className="text-center py-10">
          <div className="mx-auto h-16 w-16 text-gray-400 mb-3">📋</div>
          <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Seu histórico de notificações aparecerá aqui.</p>
        </div>
      </div>*/}
    </div>
  );
};

export default NotificationsPanel;